<template>
  <div class="form-group">
    <label class="custom-label"
      :for="id" v-text="label"
    />
    <input class="form-control"
      :id="id"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
  </div>
</template>

<script>
  export default {
    props: ['label', 'value'],
    computed: {
      id() {
        return this.label.toLowerCase().replace(' ', '-')
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/CustomInput.vue